import Report from './simple-report';

export default new Report();